import Lightbox from "bs5-lightbox";

Lightbox.initialize
